import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";

import {
  ICreateBasketPromoPayload,
  ICreatePromoPayload,
  IGetQueryParams,
} from "../interfaces/Index";
import PromosCityLevelPage from "../components/pages/PromosCityLevel/PromosCityLevelPage";
import { RootState } from "redux/reducers/RootReducer";
import { IUpdatePromoPayload } from "interfaces/userLevelPromo.interface";
import { PromoType } from "components/pages/PromosCityLevel/constants/AddBulkPromosCityLevelConstats";

export const mapStateToProps = (state: RootState): any => {
  const { promosCityLevel, zone, category, customer } = state;
  return {
    isLoading: promosCityLevel.isLoading,
    isError: promosCityLevel.isError,
    error: promosCityLevel.error,
    isPromoAdded: promosCityLevel.isPromoAdded,
    promosCityLevel: promosCityLevel.promosCityLevel,
    pagination: promosCityLevel.pagination,
    isPromoUpdated: promosCityLevel.isPromoUpdated,
    isFetchPromosLoading: promosCityLevel.isFetchPromosLoading,
    isFetchPromosError: promosCityLevel.isFetchPromosError,
    promoDetails: promosCityLevel.promoDetails,
    isPromoDetailsFetched: promosCityLevel.isPromoDetailsFetched,
    isPromoByTypeFetched: promosCityLevel.isPromoByTypeFetched,
    isPromoByTypeFetchError: promosCityLevel.isPromoByTypeFetchError,
    promosByType: promosCityLevel.promosByType,
    typePromo: promosCityLevel.typePromo,
    isFetchCategoryLoading: category.isFetchCategoryLoading,
    isFetchCategoryError: category.isFetchCategoryError,
    commandoCategoryError: category.error,
    commandoProductCategories: category.categories,
    citiesList: zone.citiesList,
    isCityListFetched: state.zone.isCityListFetched,
    warehouseList: promosCityLevel.warehouseList,
    promoId: promosCityLevel.promoId,
    promoDescription: promosCityLevel.promoDescription,
    isWarehouseFetched: promosCityLevel.isWarehouseFetched,
    ucList: promosCityLevel.ucList,
    isUcFetched: promosCityLevel.isUcFetched,
    //user level promo csv state
    isUserLevelPromoCsvLoading: promosCityLevel.isUserLevelPromoCsvLoading,
    isUserLevelPromoCsvUploaded: promosCityLevel.isUserLevelPromoCsvUploaded,
    isUserLevelPromoCsvError: promosCityLevel.isUserLevelPromoCsvError,
    userLevelPromoCsvError: promosCityLevel.userLevelPromoCsvError,
    customerConfig: customer.customerConfig,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    fetchCities: () => dispatch(actions.fetchCities()),
    fetchPromos: (cityId: string, queryPrams?: IGetQueryParams) =>
      dispatch(actions.getPromosCityLevel(cityId, queryPrams)),
    fetchPromoDetails: (id: string) =>
      dispatch(actions.getPromoCityLevelDetails(id)),
    clearPromoDetails: () =>
      dispatch(actions.clearPromoCityLevelDetailsAction()),
    createPromo: (cityId: string, payload: ICreatePromoPayload) =>
      dispatch(actions.createPromoCityLevel(cityId, payload)),
    updatePromoStatus: (id: string) =>
      dispatch(actions.updatePromoCityLevelStatus(id)),
    updatePromo: (id: string, payload: IUpdatePromoPayload) =>
      dispatch(actions.updatePromoCityLevelActions(id, payload)),
    createBasketLevel: (cityId: string, payload: ICreateBasketPromoPayload) =>
      dispatch(actions.createBasketPromoCityLevel(cityId, payload)),
    getPromoByType: (cityId: string, type: string) =>
      dispatch(actions.getPromoCityLevelByType(cityId, type)),
    getWarehouseByCityId: (cityId: string) =>
      dispatch(actions.getWarehouseByCityIdActions(cityId)),
    getUCByCityId: (cityId: string) =>
      dispatch(actions.getUCByCityIdActions(cityId)),
    getCommandoCategories: (
      isProductDetailPage: boolean,
      queryPrams?: IGetQueryParams
    ) => dispatch(actions.getCategoriesList(isProductDetailPage, queryPrams)),
    uploadUserLevelPromoCsv: (promoId: string, payload: FormData) =>
      dispatch(actions.uploadUserLevelPromoActions(promoId, payload)),
    createUploadUserLevelPromoCsv: (
      cityId: string,
      payload: ICreatePromoPayload,
      csvPayload: FormData
    ) =>
      dispatch(
        actions.createUploadUserLevelPromoActions(cityId, payload, csvPayload)
      ),
    fetchCustomerConfig: () => dispatch(actions.fetchCustomerConfig()),
    createUserLevelPromoBulk: (payload: FormData, promoType: PromoType) =>
      dispatch(actions.createPromoBulkActions(payload, promoType)),
    deactivateUserLevelPromoBulk: (payload: FormData) =>
      dispatch(actions.deactivatePromoBulkActions(payload)),
  };
};

const PromosCityLevelContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PromosCityLevelPage);
export default PromosCityLevelContainer;
